import React from 'react';
import { CTAButton } from './CTAButton';
export function BeforeAfter() {
  return <section className="py-16 px-4 bg-[#1E1E54]" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 uppercase text-[#FFFFFF] bg-[#1E1E54]" data-id="element-20">
          ANTES VS DESPUÉS
        </h2>

        <div className="grid grid-cols-2 gap-3 md:gap-8 mb-8 md:mb-12" data-id="element-21">
          {/* Before */}
          <div className="bg-red-50 p-4 md:p-8 rounded-xl md:rounded-2xl border-2 border-red-100 relative" data-id="element-22">
            <h3 className="text-sm md:text-2xl font-bold text-red-800 mb-3 md:mb-6 text-center border-b border-red-200 pb-2 md:pb-4" data-id="element-23">
              Antes del MegaPack
            </h3>
            <ul className="space-y-2 md:space-y-4" data-id="element-24">
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-25">
                <span className="text-red-500 font-bold" data-id="element-26">✖</span> Improvisación
                constante
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-27">
                <span className="text-red-500 font-bold" data-id="element-28">✖</span> Cobrar barato
                por miedo
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-29">
                <span className="text-red-500 font-bold" data-id="element-30">✖</span> Arruinar
                pinturas por no saber
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-31">
                <span className="text-red-500 font-bold" data-id="element-32">✖</span> Trabajar
                mucho para ganar poco
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-33">
                <span className="text-red-500 font-bold" data-id="element-34">✖</span> Estrés antes
                de cada servicio
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-red-900 font-medium text-xs md:text-lg" data-id="element-35">
                <span className="text-red-500 font-bold" data-id="element-36">✖</span> No saber cómo
                conseguir clientes
              </li>
            </ul>
          </div>

          {/* After */}
          <div className="bg-green-50 p-4 md:p-8 rounded-xl md:rounded-2xl border-2 border-green-500 relative shadow-xl" data-id="element-37">
            <div className="absolute -top-3 md:-top-5 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-3 py-0.5 md:px-6 md:py-1 rounded-full font-black text-xs md:text-lg uppercase tracking-wider shadow-md" data-id="element-38">
              ¡Mejor!
            </div>
            <h3 className="text-sm md:text-2xl font-bold text-green-800 mb-3 md:mb-6 text-center border-b border-green-200 pb-2 md:pb-4" data-id="element-39">
              Después del MegaPack
            </h3>
            <ul className="space-y-2 md:space-y-4" data-id="element-40">
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-41">
                <span className="text-green-600" data-id="element-42">✔</span> Protocolo claro para
                cada trabajo
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-43">
                <span className="text-green-600" data-id="element-44">✔</span> Precios seguros y
                bien justificados
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-45">
                <span className="text-green-600" data-id="element-46">✔</span> Técnica correcta en
                cada etapa
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-47">
                <span className="text-green-600" data-id="element-48">✔</span> Más plata por el
                mismo tiempo
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-49">
                <span className="text-green-600" data-id="element-50">✔</span> Confianza total al
                trabajar
              </li>
              <li className="flex items-start gap-1.5 md:gap-3 text-green-900 font-bold text-xs md:text-lg" data-id="element-51">
                <span className="text-green-600" data-id="element-52">✔</span> Agenda llena con
                clientes que vuelven
              </li>
            </ul>
          </div>
        </div>

        <CTAButton href="https://checkout.construyeprogreso.com/cart/48119785324714:1" text="👉 QUIERO TRANSFORMAR MI NEGOCIO" data-id="element-53" />
      </div>
    </section>;
}